import {EventEmitter, forwardRef, Input, Output} from "@angular/core";
import {createEvent} from "../misc/event.polyfill";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {MicroFormService} from "./micro-form.service";
import {GqlMicroFormMutationModelFactory} from "../graphql/graphql.model";

export abstract class MicroFormModel implements ControlValueAccessor {
  static OUTPUTS = [
    "savedEmitter: saved",
    "errorEmitter: error",
    "cancelledEmitter: cancelled",
    "onChangeEmitter: onChange",
  ];

  static INPUTS = [
    "saveUrl",
    "paramName",
  ];

  @Input()
  mutation: GqlMicroFormMutationModelFactory;

  @Input()
  baseParams: any;

  @Input()
  saveUrl: string;

  @Input()
  paramName: string;

  @Input()
  allowEditing: boolean;

  editing: boolean = false;
  editorValue: string;
  displayValue: string;

  @Output("saved")
  savedEmitter: EventEmitter<Event> = new EventEmitter();

  @Output("error")
  errorEmitter: EventEmitter<Event> = new EventEmitter();

  @Output("cancelled")
  cancelledEmitter: EventEmitter<Event> = new EventEmitter();

  @Output("onChange")
  onChangeEmitter: any = new EventEmitter();

  onChange: any = (_) => {}; // eslint-disable-line
  onTouched: any = () => {};

  private emitOnChange(value: string, oldValue: string): void {
    const event = createEvent("change");
    event["value"] = value;
    event["oldValue"] = oldValue;
    this.onChangeEmitter.emit(event);
  }

  get value(): string {
    return this.displayValue;
  }

  set value(value: string) {
    const oldValue = this.displayValue;
    this.displayValue = value;
    this.editorValue = value;

    if (value === oldValue) return;
    if (value === null || value === undefined) return;
    if (oldValue === null || oldValue === undefined) return;

    this.onChange(value);
    this.emitOnChange(value, oldValue);
  }

  writeValue(value: string) {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  edit(): void {
    if (!this.allowEditing) return;
    this.editing = true;
  }

  stopEditing(): void {
    this.editing = false;
  }

  save(): void {
    if (!this.allowEditing) return;
    this.microFormService.save(this);
  }

  cancel(): void {
    this.microFormService.cancel(this);
  }

  constructor(public microFormService: MicroFormService) {
  }
}

export function microFormProvider(type: any) {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => type),
    multi: true,
  };
}
